import type { Entry } from "contentful";

import { useContentfulInspectorMode } from "@contentful/live-preview/react";

import { H3, P } from "~/components/ui/text";
import type { TypeTextArticleWithMediaSkeleton } from "~/contentful/compiled";

import { ContentfulImage } from "./contentful-image";
import { RichTextRender } from "./rich-text";

export const StickySection = ({
  content,
}: {
  content: Entry<
    TypeTextArticleWithMediaSkeleton,
    "WITHOUT_UNRESOLVABLE_LINKS",
    string
  >;
}) => {
  const inspectorProps = useContentfulInspectorMode();
  if (!content) return null;
  return (
    <div className="relative my-7 flex sm-max:block">
      <div className="relative block h-inherit w-2/5 pr-4 align-top sm-max:w-full sm-max:pb-4 sm-max:pr-0">
        <div
          className="prose sticky top-14 pr-5"
          itemProp="abstract"
          {...inspectorProps({
            entryId: content.sys.id,
            fieldId: "name",
          })}
        >
          <H3 className="my-2">{content.fields.title}</H3>
          <P className="text-lg font-thin" as="div">
            <RichTextRender
              entryId={content.sys.id}
              content={content.fields.textContent}
            />
          </P>
        </div>
      </div>
      <div className="inline-block w-3/5 pt-20 sm-max:w-full sm-max:pt-0">
        <div
          className="w-full"
          itemProp="abstract"
          {...inspectorProps({
            entryId: content.sys.id,
            fieldId: "name",
          })}
        >
          {content.fields.mediaCollection.map(media => (
            <div
              className="inline-block h-80 w-1/2 px-2 align-top odd:-mt-20 last:odd:m-0 last:odd:w-full sm-max:my-4 sm-max:h-auto sm-max:w-full sm-max:odd:mt-0"
              key={media?.fields.title}
            >
              {media?.fields.file && (
                <ContentfulImage
                  alt={media?.fields.title ?? ""}
                  imageUrl={media?.fields.file?.url}
                  className="h-56 w-full max-w-[50%] object-cover"
                  itemProp="image"
                />
              )}
              <P className="line-clamp-3 text-base" variant="muted">
                {media?.fields.description}
              </P>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
